<template>
  <div class="lg-bordered-tabs">
    <v-tabs class="tabs" v-model="active" color="#fff" hide-slider centered>
      <v-tab
        v-for="(tab, index) in settings.tabs"
        :key="tab.id"
        @click="tabChange(index)"
      >
        {{ tab.label }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>

export default {
  name: 'Tabs',
  props: {
    settings: {
      // keys are tabs, preselected, enableRouting
      // preselected is only
      type: Object,
      default: () => {
        return {
          preselected: null, // if not using router, you can preselect upon creation with id
          tabs: []
        }
      }
    }
  },
  created: function() {
    const vm = this
    // setTimeout(function () {
    //     vm.$router.push({name: vm.settings.tabs[2].id})
    // }, 3000)
  },
  data: function() {
    return {
      active: this.settings.preselected
        ? this.settings.tabs.map(d => d.id).indexOf(this.settings.preselected)
        : this.getRouterMatchedTabIndex(this.$router.currentRoute)
    }
  },
  watch: {
    $route(to, from) {
      // beforeRouteUpdate doesn't work
      this.active = this.getRouterMatchedTabIndex(to)
    }
  },
  methods: {
    tabChange: function(tab) {
      console.log('tab', tab)
      console.log(this.settings)
      if (tab >= 0 && tab < this.settings.tabs.length)
        this.$router.push({ name: this.settings.tabs[tab].id, query: this.$router.currentRoute.query })
    },
    getRouterMatchedTabIndex: function(to) {
      for (let i = 0; i < this.settings.tabs.length; i++) {
        const tmp = to.matched.find(f => f.name === this.settings.tabs[i].id)
        if (tmp) return i
      }
    }
  }
}
</script>

<style lang="stylus">
.lg-bordered-tabs {
    .v-tabs__item {
        padding-left 25px
        padding-right 25px
    }
    .v-tabs__item:not(.v-tabs__item--active) {
        opacity 1
    }

    .v-tabs__bar .v-tabs__div {
        color $color-primary
        font-weight normal
        height 40px
        .v-tabs__item {
            border: 1px solid $color-primary-light-8;
            box-sizing: border-box;
            text-transform none
            min-width 85px
        }
        &:first-child {
            .v-tabs__item {
                border-radius: 5px 0px 0px 5px
                border-right 0px
            }
        }
        &:last-child {
            .v-tabs__item {
                border-left 0px
                border-radius: 0px 5px 5px 0px
            }
        }
        .v-tabs__item--active {
            font-weight 500
            border-color: $color-primary-light-1;
            background-color $color-primary-light-1
            color: #fff
        }
    }
}
</style>
